import { Col, Flex, Row, Slider as AntdSlider } from 'antd';
import { Input, Button } from '../../index';
import { useTranslation } from 'react-i18next';

const SliderContent = ({
  handleSliderChange,
  clickOnApplyButton,
  inputChange,
  clickOnResetButton,
  stepSize,
  maxValue,
  minValue,
  maxRange,
  minRange,
  isAdvancedFilter,
}) => {
  const { t } = useTranslation();

  return (
    <div style={isAdvancedFilter ? { maxWidth: 380 } : { maxWidth: 270 }}>
      <Row gutter={8} align={'middle'}>
        <Col span={11}>
          <Input
            placeholder={'Min'}
            value={minValue}
            onChange={(e) => inputChange({ name: 'min', value: e.target.value })}
            style={{ width: '100%' }}
            type="number"
          />
        </Col>

        <Col span={2} className="text-center">
          -
        </Col>

        <Col span={11}>
          <Input
            placeholder={'Max'}
            value={maxValue}
            onChange={(e) => inputChange({ name: 'max', value: e.target.value })}
            style={{ width: '100%' }}
            type="number"
          />
        </Col>

        <Col span={24}>
          <AntdSlider
            range={{ draggableTrack: true }}
            min={minRange}
            max={maxRange}
            step={stepSize}
            value={[minValue, maxValue]}
            onChange={(values) => handleSliderChange(values)}
          />
        </Col>
      </Row>
      {parseInt(minValue) > parseInt(maxValue) ? (
        <div style={{ color: 'var(--ant-color-error)' }}>
          {t('Minimum value cannot be greater than the Maximum value')}
        </div>
      ) : (
        <div></div>
      )}
      <Flex justify="end" gap={8}>
        <Button className="mr-3" onClick={clickOnResetButton} text={'Reset'} type="link" danger size="small" />
        <Button
          disabled={parseInt(minValue) > parseInt(maxValue) ? true : false}
          size="small"
          onClick={clickOnApplyButton}
          text={'Apply'}
        />
      </Flex>
    </div>
  );
};

export default SliderContent;
